import { render, staticRenderFns } from "./CFormSelect.vue?vue&type=template&id=30b898f2&"
import script from "./CFormSelect.vue?vue&type=script&lang=js&"
export * from "./CFormSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports